<template>
  <div class="lampStrategys-content">
    <div class="tab-head">
      <div class="item item1" :class="tabValue==='light'?'curr':''" @click="checkTab('light')">定时策略</div>
      <div class="item item2" :class="tabValue==='area'?'curr':''" @click="checkTab('area')">区域策略</div>
    </div>
    <div class="con-body">
      <strategy-time v-show="tabValue==='light'" ref="addStrategy" :stgId="stgId"></strategy-time>
      <strategy-area v-show="tabValue==='area'" ref="strategyArea"></strategy-area>
    </div>
  </div>
</template>
<script>
import strategyTime from "@/views/light/strategys/strategyTime.vue"
import strategyArea from "@/views/light/strategys/strategyArea.vue"
export default {
  components: { 
    strategyTime,
    strategyArea
  },
  data() {
    return {
      tabValue: 'light',
      stgId: null
    };
  },
  created() {
    let stgId = this.$route.params.stgId;
    if(stgId){
      this.stgId=stgId
    }
  },
  methods: {
    checkTab(value) {
      this.tabValue = value
    }
  }
};
</script>

<style lang='less'>
.lampStrategys-content{

  // <div class="tab-head">
  //     <div class="item item1" :class="tabValue==='light'?'curr':''" @click="checkTab('light')">路灯策略</div>
  //     <div class="item item2" :class="tabValue==='light'?'curr':''">区域策略</div>
  //   </div>
  //   <div class="tab-body">
  
  .tab-head{
    display: flex;
    align-items: center;
    .item{
      background-color: #edeff2;
      height: 56px;
      display: flex;
      align-items: center;
      border-top-left-radius: 18px;
      border-top-right-radius: 18px;
      color: #86909c;
      padding:6px 50px 0;
      font-size: 16px;
      padding-top: 6px;
      position: relative;
      box-sizing: border-box;
      cursor: pointer;
      &.curr{
        color:#2d8cf0;
        background-color: #ffffff;
        &::after,&::before{
          content:"　";
          display: block;
          width:10px;
          height:10px;
          background: url(../../../assets/images/tab_radius.png) center bottom no-repeat;
          background-size: 100% 99.9%;
          position: absolute;
          bottom: -1px;
          z-index: 3;
        }
      }
      &.item1.curr::after{
        right:-9px;
      }
      &.item1.curr::before{
        display: none;
      }
      &.item2.curr::after{
        right:-9px;
      }
      &.item2.curr::before{
        left:-9px;
        transform: rotateY(180deg)
      }
    }
  }
}
</style>
